<template>
  <!-- 幻灯片管理 -->
    <operateButton @btn-handle="btnHandle" @btn-in-table="btnInTable"
        :style="btnLeftList.length > 0 ? '' : 'display:block;'" @btn-on-left="btnOnList" />
  <el-button-group v-if="false">
    <el-button type="primary" size="large" @click="addEditFnc('', $event)"
      ><el-icon><Plus /></el-icon>添加</el-button
    >
  </el-button-group>
  <!-- 卡片式 列表 -->
  <div
    class="contain"
    :style="{ height: tableMaxHeight + 50 + 'px' }"
    v-loading="loading"
  >
    <template v-if="tableData.length > 0">
      <ul v-for="(item, index) in tableData" :key="index">
        <li class="detail">
          <div class="detail-content">
            <!-- <div
                class="order_number"
                :class="index == 0 ? 'yellow_number' : 'blue_number'"
              >
                {{ item.order }}
                <i class="triangle"></i>
              </div> -->

            <div class="detail-header">
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.title"
                placement="top"
              >
                <el-image
                  v-if="item.imagePath"
                  title="点击查看大图"
                  class="focus-img"
                  :src="item.imagePath"
                  :preview-src-list="[item.imagePath]"
                >
                </el-image>
              </el-tooltip>
            </div>
            <div>
              <span class="gray">所属分类：</span>
              <span :class="item.channelName ? '' : 'gray'">
                {{ item.channelName ? item.channelName : "未设置" }}
              </span>
            </div>
            <div>
              <span class="gray">投放终端：</span>
              <span :class="item.slideCategoryName ? '' : 'gray'">
                {{ item.slideCategoryName ? item.slideCategoryName : "未设置" }}
              </span>
            </div>
            <div>
              <span class="gray">跳转链接：</span>
              <span v-if="item.linkUrl">
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
                >
                <template #content>
                   <span class="handLinkUrl">{{ item.linkUrl }}</span>
                </template>
                  <a class="blue hand" :href="item.linkUrl" target="_blank"
                    >点击跳转</a
                  >
                </el-tooltip>
              </span>
              <span class="gray" v-else>未设置</span>
            </div>

            <div>
              <span class="gray">创建时间：</span>
              <span>{{ timeFormat(item.createTime, "yyyy-MM-dd hh:mm") }}</span>
            </div>
          </div>
          <div class="detail-button">
            <el-button v-for="(item1,index) in buttonList" :key="index" :type="item1.className" @click="doEvent(item1.eventName, item)" :plain="!item1.isPlain">{{ item1.name }}</el-button>
          </div>
        </li>
      </ul>
    </template>
    <i v-else style="color: gray; margin: auto">暂无数据</i>
  </div>
  <!-- 添加编辑 幻灯片 -->
  <el-dialog
      class="dialogNoPadding"
    :before-close="handleClose"
    :close-on-click-modal="false"
    v-model="addEditSlideVisible"
    :title="dialogTitle"
    width="650px"
     draggable
              destroy-on-close
  >
    <AddEditSlide
      ref="AddEditComponent"
      v-if="addEditSlideVisible"
      :edit-id="editId"
      @close-dialog="closeDialog"
      @update-list="updateList"
    ></AddEditSlide>
  </el-dialog>
</template>
<script>
import { getSlides, deleteSlide } from "network/slideManagement.js";
import { reactive, onMounted, toRefs, ref, toRaw ,h ,computed, nextTick} from "vue";
import AddEditSlide from "views/slideManagement/AddEditSlide.vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { lostFocus, timeFormat } from "common/utils";
import store from "../../store/index";
export default {
  name: "SlideManagement",
  props: {
    tableMaxHeight: Number,
  },
  components: {
    AddEditSlide,
  },
  setup() {
    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
      isDelect: computed(() => {
        return (
          store.state.isDelect ||
          JSON.parse(sessionStorage.getItem("isDelect"))
        );
      }),
      tableData: [],
      // 表格是否在加载中
      loading: true,
      dialogTitle: "添加幻灯片",
      addEditSlideVisible: false, //添加编辑弹窗
      multipleSelection:[],
      editId: 0,
    });

    //挂载后调用函数获取项目数据
    onMounted(() => {
      getListData(); //请求幻灯片列表数据
    });

    //更新列表
    const updateList = () => {
      getListData();
    };
    //获取列表
    const getListData = () => {
      data.loading = true;
      getSlides()
        .then((result) => {
          
          if (result && result.code == 1) {
            data.tableData = result.result;
            data.loading = false;
          } else {
            data.loading = false;
            ElMessage.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    // 添加/编辑幻灯片
    const addEditFnc = () => {
      const obj = toRaw(data.multipleSelection[0]);
      data.addEditSlideVisible = true;
      if (data.multipleSelection[0]) {
        data.dialogTitle = `编辑【${obj.title}】幻灯片`;
        data.editId = obj.id;
      } else {
        data.dialogTitle = "添加幻灯片";
        data.editId = 0;
      }
    };
    //关闭弹窗
    const closeDialog = () => {
      data.addEditSlideVisible = false;
    };

    // 删除
    const deleteFnc = () => {
      /*这个变量是我们定义的reactive对象，打印出来他是一个数据代理的实例，并非array(),所以想要把获取的报文数据复制到里面，需要使用深拷贝*/
      const obj = toRaw(data.multipleSelection[0]);
         ElMessageBox({
        title: "删除",
        message: h("p", null, [
          h("span", null, "是否删除【"),
          h(
            "b",
            { style: "color: #fd5252;font-size:16px;" },
            `${obj.title}`
          ),
          h("span", null, "】幻灯片？ "),
        ]),
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确认",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 开启按钮加载
            instance.confirmButtonLoading = true
            instance.confirmButtonText = "确认中"
            // 删除接口
            deleteSlide(obj.id)
            .then((result) => {
              if (result && result.code == 1) {
                done();
                ElMessage.success(result.message);
                updateList();
              } else {
                done();
                ElMessage.error(result.message);
              }
            })
            .catch((err) => {
              done();
              ElMessage.error(err.message);
            })
          } else {
            done();
          }
        },
      })
        // .then(() => {
        //   deleteData(obj.id);
        // })
        .catch(() => {
          ElMessage("取消删除");
        });
    };
    function deleteData(id) {
      deleteSlide(id)
        .then((result) => {
          
          if (result && result.code == 1) {
            ElMessage.success(result.message);
            updateList();
          } else {
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    //关闭添加编辑弹窗操作
    const AddEditComponent = ref();
    const handleClose = () => {
      if (data.addEditSlideVisible) {
        AddEditComponent.value.resetForm();
        data.addEditSlideVisible = false;
      }
    };
  const doEvent = function (btn, row) {
  try {
    data.multipleSelection = [];
    data.multipleSelection.push(row);
    eval(btn.split("(")[0] + `()`);
  }
  catch (err) {
    console.log(err);
    
    ElMessageBox.alert("err");
  }
}
    const btnHandle = (val) => {
      try {
        eval(val);
      } catch (error) {
        ElMessage.error("按钮事件不存在");
      }
    };
    const btnLeftList = ref([]);
    const buttonList = ref([]);
    const btnOnList = (val) => {
      btnLeftList.value = val ? val : [];
    }
    const btnInTable = async (val) => {
      if (val?.length > 0) {
        // 先设置按钮数据并插入列定义
        buttonList.value = val;
      }
    };
    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      getListData,
      updateList,
      closeDialog,
      addEditFnc,
      deleteFnc,
      timeFormat,
      AddEditComponent,
      handleClose,
      btnInTable,
      btnLeftList,
      buttonList,
      btnOnList,
      btnHandle,
      doEvent,
    };
  },
};
</script>

<style scoped>
.contain {
  width: 100%;
  background: #f5f6fa;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  overflow-y: scroll;
  box-sizing: border-box;
}

.contain ul {
  width: 25%;
}
.detail {
  position: relative;
  border-radius: 8px;
  box-shadow: 10px 10px 5px rgb(238, 236, 236);
  background: #fff;
  margin: 20px 15px 0px 15px;
  line-height: 30px;
  padding: 15px 20px 20px 15px;
  box-sizing: border-box;
  /* overflow-y: scroll; */
  /* position: relative; */
}

.detail-content {
  height: 260px;
  /* overflow-y: scroll; */
}

.detail-header {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
}

.focus-img {
  width: 200px;
  height: 100px;
  border-radius: 8px;
  margin-right: 20px;
}

.detail-button {
  text-align: center;
}
.handLinkUrl{
  max-width: 300px;
   word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}
.order_number {
  width: 60px;
  height: 30px;
  line-height: 30px;
  position: absolute;
  top: -12px;
  left: -10px;
  text-align: center;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  color: #fff;
  font-size: 16px;
  box-shadow: 10px 10px 10px #ddd;
}
.yellow_number {
  background-color: coral;
}
.blue_number {
  background-color: #409eff;
}
.triangle {
  position: absolute;
  top: -18px;
  position: absolute;
  top: 0px;
  width: 0;
  height: 0;
  border-width: 12px 0px 0px 12px;
  border-style: solid;
  box-shadow: 6px 18px 10px #ddd;
}
.yellow_number .triangle {
  left: 60px;
  border-color: transparent coral;
}
.blue_number .triangle {
  left: 60px;
  border-color: transparent #409eff;
}
</style>